import { Button, Modal, Space, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useMemberId } from "pages/member"

import { useNavigate } from "react-router-dom"
import { useBecomeMember } from "./queries"

interface Props {
  open: (data?: any) => void
  onClose: () => void
  isOpen: boolean
  data?: any
}

const BecomeMemberModal: React.FC<Props> = ({ data, ...props }) => {
  const { t } = useTranslation("translation")
  const navigate = useNavigate()
  const memberId = useMemberId()

  const { isLoading, mutate } = useBecomeMember(memberId!, {
    meta: { message: t("mutations.success.operation") },
  })

  const onContinue = () => {
    mutate(undefined, {
      onSuccess: () => {
        navigate(`/members/${memberId}/invoices`)
      },
      onSettled: () => {
        props.onClose()
      },
    })
  }
  return (
    <Modal
      centered
      title={t("global.become_member")}
      open={props.isOpen}
      onCancel={props.onClose}
      footer={[
        <Button key="cancel" onClick={props.onClose}>
          {t("global.cancel")}
        </Button>,
        <Button
          onClick={onContinue}
          loading={isLoading}
          type="primary"
          key="delete"
        >
          {t("global.continue")}
        </Button>,
      ]}
      key={data?.id}
    >
      <Space direction="vertical" size={5}>
        <Typography.Text>{t("global.become_member_msg1")}</Typography.Text>
        <Typography.Text>{t("global.become_member_msg2")}</Typography.Text>
        <Typography.Text>{t("global.become_member_msg3")}</Typography.Text>
      </Space>
    </Modal>
  )
}

export default BecomeMemberModal
